<template>
  <v-container class="text-center pr-0 pl-0" fluid>
    
    <assinatura-box :item="assinatura" v-for="assinatura in $store.getters.assinaturas" :key="assinatura.id"/>

  </v-container>
</template>

<script>
import AssinaturaBox from '../components/AssinaturaBox.vue';

//import axios from 'axios';
//import HOST from '../ws'
//import SnackBar from "../snackbar";


export default {
  props: {
    
  },

  components : {
    AssinaturaBox,
  },

  data: () => ({
    
    items : null,

  }),

  methods : {

    
  }
};
</script>